import { useFormContext } from "@/app/components/formContext/formcontext";
import VehicleCardRural from "@/app/components/ServicesComponents/RuralCard";
import {
  CustomPaging,
  SampleNextArrow,
  SamplePrevArrow,
} from "@/app/components/swipersComponents";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { withServicesLayout } from "@/pages/_layoutService";

function ProdutorRural() {
  const { setOptions, setInputValue } = useFormContext();
  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1140,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    autoplay: true,
    autoplaySpeed: 5000,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentIndex(newIndex);
    },
    customPaging: (index: number) => {
      return (
        <CustomPaging
          key={"pagging-produtor-rural" + index}
          index={index}
          currentIndex={currentIndex}
        />
      );
    },
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };
  const hiluxModels = [
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/hilux_chassi.png",
      name: "HILUX CHASSI",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/hilux_cabine_dupla.png",
      name: "HILUX CABINE DUPLA",
      details: "STD PP",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/hilux_cabine_simples.png",
      name: "HILUX CABINE SIMPLES",
      details: "",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/hilux_sr.png",
      name: "HILUX CABINE DUPLA",
      details: "SR",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/hilux_srv.png",
      name: "HILUX CABINE DUPLA",
      details: "SRV",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/sw4_5l.png",
      name: "SW4",
      details: "5 LUGARES",
      year: "2024/2024",
    },
    {
      imageSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/LP-VD/Produtor%20Rural/sw4_7l.png",
      name: "HILUX SW4",
      details: "7 LUGARES",
      year: "/2024",
    },
  ];
  const models = hiluxModels.map(
    (m) => `${m.name} ${m.details == "" ? "" : "-"} ${m.details}`
  );

  useEffect(() => {
    setOptions([...models]);
  }, []);
  return (
    <>
      <div className="w-full text-zinc-800 p-3">
        <div className="w-full  lg:h-40 mt-5 lg:p-3 ">
          <h1 className="text-[40px]  text-black leading-[57.6px] max-md:max-w-full max-md:text-4xl">
            Produtor Rural
          </h1>
          <div className="w-16 border-b-2 ml-1 border-red-600 " />
        </div>
        <p className="mt-10">
          Os veículos Toyota são reconhecidos em todo o mundo por sua qualidade
          e confiabilidade. Projetados para enfrentar os desafios do campo,
          nossos veículos são construídos para durar e oferecer desempenho
          consistente, mesmo nas condições mais adversas.
          <br />
          <br />
          Na Toyota, reconhecemos o papel crucial desempenhado pelos produtores
          rurais no desenvolvimento e sustentabilidade do nosso país.
          Compreendemos as demandas únicas enfrentadas no campo e estamos
          comprometidos em oferecer soluções automotivas que atendam às suas
          necessidades específicas.
          <br />
          <br />
          Entre em contato conosco para descobrir mais sobre nossos descontos
          especiais para produtores rurais e dar o próximo passo para um
          transporte confiável e eficiente.
        </p>
        <h2 className="text-2xl py-5">
          Como você se enquadra na categoria Produtor Rural?
        </h2>
        <p className="pb-5">
          O desconto para produtor rural é concedido a quem exerce atividades
          e/ou tem propriedades ligadas ao cultivo da terra ou, ainda, para
          criação de animais. Alguns exemplos:
        </p>
        <ul className="list-disc list-inside decoration-zinc-800 px-3">
          <li key="piscicultura">Piscicultura</li>
          <li key="pecuarias">Pecuárias</li>
          <li key="suinocultura">Suinocultura</li>
          <li key="empresario">Empresário</li>
          <li key="avicultura">Avicultura</li>
          <li key="atividades-agricolas">Atividades agrícolas</li>
          <li key="apicultura">Exploração da apicultura</li>
          <li key="extracao-vegetal">Extração e a exploração vegetal</li>
        </ul>
        {/*<h2 className="text-2xl py-5">
          Quais veículos você pode comprar com desconto direto de fábrica como
          Produtor Rural?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 max-lg:hidden">
          {hiluxModels.map((vehicle, index) => (
            <VehicleCardRural
              key={"cardVehicle.rural" + index}
              imageSrc={vehicle.imageSrc}
              name={vehicle.name}
              details={vehicle.details}
              year={vehicle.year}
              onClick={() => {
                setInputValue(models[index]);
              }}
            />
          ))}
        </div>
        <div className="flex flex-col gap-5 lg:hidden mb-20">
          <Slider {...settings}>
            {hiluxModels.map((vehicle, index) => (
              <VehicleCardRural
                key={"cardVehicle.rural.mbl" + index}
                imageSrc={vehicle.imageSrc}
                name={vehicle.name}
                details={vehicle.details}
                year={vehicle.year}
                onClick={() => {
                  setInputValue(models[index]);
                }}
              />
            ))}
          </Slider>
        </div>*/}
        <h2 className="text-2xl py-5">Documentações necessárias:</h2>
        <p className="pb-5">
          - Ficha cadastral de Empresário individual ou Contrato Social ou Ato
          Constitutivo;
          <br />
          - Ata de eleição da Diretoria e/ou Procuração se houver;
          <br />
          - RG/CPF ou documento equivalente do administrador ou representante
          legal da empresa;
          <br />
          - Cartão CNPJ (Situação Ativa);
          <br />- Inscrição Estadual (Situação Regular)
        </p>
      </div>
    </>
  );
}
export default withServicesLayout(ProdutorRural);
export { getServerSideProps } from "@/pages/_layoutService";
